import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchProjectCategories } from '../../services/api';
import {
  createProjectCategory,
  updateProjectCategory,
  deleteProjectCategory,
  setDefaultProjectCategory,
  reorderProjectCategories
} from '../../services/adminApi';
import { useCrudResource } from '../../hooks/useCrudResource';
import Button from '../../components/admin/ui/Button';
import Loader from '../../components/admin/ui/Loader';
import EntityTable from '../../components/admin/EntityTable';
import EntityForm from '../../components/admin/EntityForm';
import EntityFormPage from '../../components/admin/EntityFormPage';
import AdminProjectsSubnav from '../../components/admin/AdminProjectsSubnav';
import { projectCategoryColumns, projectCategoryFields } from '../../config/admin/projects.config';

function AdminProjectCategoriesPage({ showToast }) {
  const navigate = useNavigate();
  const { items: categories, loading, reload, createItem, removeItem } = useCrudResource(
    { fetchAll: fetchProjectCategories, create: createProjectCategory, update: updateProjectCategory, remove: deleteProjectCategory },
    { showToast, entityLabel: 'Catégorie' }
  );
  const [view, setView] = useState('list');

  const handleReorder = async (ids) => {
    await reorderProjectCategories(ids);
    await reload();
  };

  const handleSetDefault = async (category) => {
    if (category.isDefault) return;
    await setDefaultProjectCategory(category.id);
    await reload();
    showToast('Catégorie par défaut mise à jour.');
  };

  const handleDelete = async (category) => {
    if (!window.confirm('Supprimer cette catégorie ?')) return;
    try {
      await removeItem(category.id);
    } catch (error) {
      showToast('Impossible de supprimer : catégorie encore utilisée par des projets.');
    }
  };

  const handleCreateSubmit = async (values) => {
    await createItem(values);
    setView('list');
  };

  if (loading) return <Loader label="Chargement des catégories..." />;

  if (view === 'form') {
    return (
      <EntityFormPage listLabel="Catégories" title="Ajouter une catégorie" onBack={() => setView('list')}>
        <EntityForm fields={projectCategoryFields} onSubmit={handleCreateSubmit} submitLabel="Créer" />
      </EntityFormPage>
    );
  }

  return (
    <section className="admin-section">
      <h2>Projets</h2>
      <AdminProjectsSubnav />

      <div className="admin-actions" style={{ justifyContent: 'flex-end', marginBottom: 'var(--space-3)' }}>
        <Button onClick={() => setView('form')}>+ Ajouter une catégorie</Button>
      </div>
      <EntityTable
        columns={projectCategoryColumns}
        rows={categories}
        onEdit={(category) => navigate(`/admin-bj/projets/categories/${category.id}`)}
        onDelete={handleDelete}
        onReorder={handleReorder}
        renderExtraActions={(category) =>
          !category.isDefault && (
            <Button variant="secondary" onClick={() => handleSetDefault(category)}>
              Définir par défaut
            </Button>
          )
        }
        emptyMessage="Aucune catégorie."
      />
    </section>
  );
}

export default AdminProjectCategoriesPage;
